export enum Form101StatusEnum {
  EMPLOYEE_FILL = 10,
  REJECTED = 15,
  EMPLOYEE_CONFIRMED = 20,
  MANAGER_CONFIRMED = 30,
  READY_FOR_SIGNING = 35,
  SEND_FOR_SIGNING = 50,
  SIGNED = 100,
  UPDATE_IPT_COMPLETE = 101,
  ALL_CONFIRMED = -2,            // NOTICE: ALL_CONFIRMED(-2) is not real status and it's only for UI dropdown
}
